<template>
	<div>

		<!-- <PageHeader :title="TR.contacts" icon="far fa-envelope" /> -->

		<div class="contacts-page container py-4" >
			<div class="row">
				<div class="col-md-6 maps p-0 pe-sm-5" v-html='map_frame'></div>
				<!-- <div class="col-md-6 maps p-0 pe-sm-5">
					<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d4942.586884624221!2d49.79720075951986!3d40.375482161256194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sru!2saz!4v1758008095258!5m2!1sru!2saz" frameborder="0" style="border:0" allowfullscreen></iframe>
				</div> -->

				<div class="col-md-6 p-2">
					<h4 class="mt-3 mt-sm-0 fw-bold">{{TR.write_us}}</h4>
					<form action="">
						<div class="row">
							<div class="col-lg-6 mt-3">
								<!-- <input type="text" class="form-control rounded-3" :placeholder="TR.firstname" @invalid="InvalidMsg($event, TR.msg_params_error)" required> -->
								<label class="form-label">{{TR.name}}</label>
								<ValidateInput2
									v-model="valid.name"
									@validate="input.validateName"
									inputType="text"
									:body="errors.name"
									:showIcon="true"
									:iconSize="24"
									:showErrorInfo="true"
									icon="person"
									:placeholder="TR.name"
								/>
							</div>
							<div class="col-lg-6 mt-3">
								<!-- <input type="text" class="form-control rounded-3" :placeholder="TR.lastname" @invalid="InvalidMsg($event, TR.msg_params_error)" required> -->
								<label class="form-label">{{TR.lastname}}</label>
								<!-- @validate="input.validateLastName" -->
								<ValidateInput2
									v-model="valid.lastname"
									inputType="text"
									:body="errors.lastname"
									:showIcon="true"
									:iconSize="24"
									:showErrorInfo="true"
									icon="list"
									:placeholder="TR.lastname"
								/>
							</div>
							<div class="col-lg-6 mt-3">
								<!-- <input type="email" class="form-control rounded-3" :placeholder="TR.email" @invalid="InvalidMsg($event, TR.msg_params_error)" required> -->
								<label class="form-label">{{TR.email}}</label>
								<ValidateInput2
									v-model="valid.email"
									@validate="input.validateEmail"
									inputType="email"
									:body="errors.email"
									:showIcon="true"
									:iconSize="24"
									:showErrorInfo="true"
									icon="at"
									:placeholder="TR.email"
								/>
							</div>
							<div class="col-lg-6 mt-3">
								<!-- <input type="text" class="form-control rounded-3" :placeholder="TR.phone"> -->
								<label class="form-label">{{TR.phone}}</label>
								<!-- @validate="input.validatePhone" -->
								<ValidateInput2
									v-model="valid.phone"
									inputType="text"
									:body="errors.phone"
									:showIcon="true"
									:iconSize="24"
									:showErrorInfo="true"
									icon="phone"
									:placeholder="TR.phone"
								/>
							</div>
							<div class="col-12 mt-3">
								<!-- <textarea class="form-control rounded-3" id="exampleFormControlTextarea1" :placeholder="TR.text" rows="5" @invalid="InvalidMsg($event, TR.msg_params_error)" required></textarea> -->
								<label class="form-label">{{TR.content}}</label>
								<ValidateTextarea
									v-model="valid.content"
									@validate="input.validateContent"
									inputType="text"
									:body="errors.content"
									:showIcon="true"
									:iconSize="24"
									:showErrorInfo="true"
									icon="body-text"
									:placeholder="TR.content"
								/>
							</div>
							<!-- <div class="col-12 mt-3">
								<div class="form-group">
									<div class="form-check">
										<input class="form-check-input cursor-pointer" type="checkbox" value="" id="rememberCheck" @invalid="InvalidMsg($event, TR.noselect)" required />
										<label class="form-check-label cursor-pointer" for="rememberCheck">
											{{ TR.agree_terms }}
										</label>
									</div>
								</div>
							</div> -->
							<div class="col-12 mt-3 text-center">
								<!-- <button class="btn btn-dark bg-site border-0 rounded-3" type="submit"><i class="fas fa-paper-plane me-2"></i>{{ TR.send }}</button> -->
								<button
									type="button"
									class="btn btn-primary px-5 g-recaptcha"
									@click="validateInput($event)"
								>
									<!-- :class="!isButtonEnabled ? 'disabled' : ''" -->
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										fill="currentColor"
										class="me-2"
									>
										<use
											xlink:href="/assets/icons/bootstrap-icons.svg#send"
										/>
									</svg>
									{{TR.send}}
								</button>
							</div>
						</div>
					</form>
					<div class="mt-5">
						<hr>
						<i class="fas fa-phone mt-3 me-2"></i> <a :href="'tel:' + G.systemData?.phone?.value">{{ G.systemData?.phone?.value }}</a><br>
						<i class="fas fa-envelope mt-3 me-2"></i> <a :href="'mailto:' + G.systemData?.email?.value">{{ G.systemData?.email?.value }}</a><br>
						<i class="fas fa-map-marked mt-3 me-2"></i>{{ G.systemData?.address?.value }}<br>
						<!-- <i class="fas fa-globe mt-3 me-2"></i> Piazza del Colosseo, 1, 00184 Roma<br> -->
						<!-- <div class="my-4">
							<a href=""><i class="fab fa-facebook fa-3x pr-4"></i></a>
							<a href=""><i class="fab fa-linkedin fa-3x"></i></a>
						</div> -->
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { onMounted, ref, watchEffect } from 'vue';
import { useStore } from '@/system_modules/store';

import { load } from 'recaptcha-v3'

import FormValidation from "@/system_modules/utils/FormValidation";
import ValidateInput2 from "@/components/field/ValidateInput2";
import ValidateTextarea from "@/components/field/ValidateTextarea";

// import PageHeader from '@/components/header/PageHeader';

import { G, ajax } from '@/_common';

export default {
	name: 'ContactsP',
	title: 'contacts',
	components: {
		ValidateInput2,
		ValidateTextarea,
	},
	props: {
		data: {
			type: Object
		}
	},
	setup() {
		const store = useStore();

		const TR = ref({});
		const map_frame = ref("");

		const valid = ref({
			name: "",
			lastname: "",
			email: "",
			phone: "",
			content: "",
			// name: "test",
			// lastname: "test",
			// email: "test@test.com",
			// phone: "1234567890",
			// content: "test tesagds fasdlkf adskjfha lkjsdf lkasd f",
			captcha: "",
		});

		// const def_lang =
		// 	route.params && route.params.lang ? route.params.lang : "az";

		watchEffect(() => {
			TR.value = store.getTranslation();
			map_frame.value = G.systemData?.address_map?.value.replace('width="600"', 'width="100%"').replace('height="450"', 'height="600"');
		});

		const {
			validateEmailField,
			validatePhoneField,
			validateTextField,
			// validateCaptcha,
			errors,
		} = FormValidation();

		const input = {
			validateName: () => {
				validateTextField("name", valid.value.name);
			},
			validateLastName: () => {
				validateTextField("lastname", valid.value.lastname);
			},
			validateEmail: () => {
				validateEmailField("email", valid.value.email);
			},
			validatePhone: () => {
				validatePhoneField("phone", valid.value.phone);
			},
			validateContent: () => {
				validateTextField("content", valid.value.content, 8);
			},
			// validateFormCaptcha: () => {
			// 	validateCaptcha("captcha", valid.value.captcha);
			// },
		};

		const InvalidMsg = (obj, txt) => {
			let th = obj !== undefined ? obj.target : undefined;
			if (th.value === '' && (th.type === 'text' || th.type === 'email' || th.type === 'textarea')) {
				th.setCustomValidity(txt);
			} else if (th.checked === false && (th.type === 'checkbox' || th.type === 'radio')) {
				th.setCustomValidity(txt);
			} else if (th.validity.typeMismatch) {
			// } else if (th.validity.valueMissing) {
				th.setCustomValidity(txt);
			} else {
				th.setCustomValidity('');
			}
			return true;
		};

		const validateInputFields = () => {
			input.validateName();
			// input.validateLastName();
			input.validateEmail();
			// input.validatePhone();
			input.validateContent();
			// input.validateFormCaptcha();
		};

		onMounted(() => {
			setTimeout(async () => {
				// await recaptchav3();
				validateInputFields();
			}, 1500);
		});

		const validateInput = async (event) => {
			validateInputFields();
			if( Object.values(errors).filter(f => f != '').length == 0 ) {
				await sendData(event);
				// recaptchav3();

				validateInputFields();
			}
			else{
				G.alert.info({msg: TR.value.msg_fill_required_field})
			}
		};

		const getCaptchaToken = async () => {
			const recaptcha = await load(G.captcha_key.value, {
				useRecaptchaNet: true,
				autoHideBadge: true
			})
			return await recaptcha.execute(G.captcha_key.value, {action: 'submit'});
		};

		const recaptchav3 = async () => {
			valid.value.captcha = await getCaptchaToken();
		// 	load(G.captcha_key.value, {
		// 			useRecaptchaNet: true,
		// 			autoHideBadge: true
		// 		}).then((recaptcha) => {
		// 		// recaptcha.execute(G.captcha_key.value, {action: 'submit'}).then((token) => {
		// 		recaptcha.execute({action: 'submit'}).then((token) => {
		// 			valid.value.captcha = token;
		// 		})
		// 	});
		};

		const sendData = async (event) => {
			await recaptchav3();
			let contact_data = {
				"name": valid.value.name,
				"lastname": valid.value.lastname,
				"email": valid.value.email,
				"phone": valid.value.phone,
				"content": valid.value.content,
				"captcha": valid.value.captcha,
			};

			await ajax({
				url: store.getContactData(),
				method: 'post',
				content_type: 'application/json',
				data: contact_data,
				success: (x) => {
					let res1 = x.data || null;
					if ( x.status == 200 && res1) {
						event.target.form.reset();
						valid.value = {
							name: "",
							lastname: "",
							email: "",
							phone: "",
							content: "",
							captcha: "",
						};
						G.alert.success(TR.value.msg_add_success);
					}
					else
						G.alert.error(res1.detail);
				},
				error: (x) => {
					var res = x.response || x;
					G.alert.warning(res.data.detail);
				}
			});
		};

		return {
			G,
			TR,
			InvalidMsg,
			map_frame,
			valid,
			input,
			errors,
			validateInput,
		};
	}
}
</script>


<style lang="scss" scoped>
// .contacts-page{
// 	letter-spacing: 2px;
// }
.contacts-page a{
	text-decoration: none;
	color: #000000;
}
iframe {
	border: 1px solid black;
	border-radius: 1rem !important;
}
input.form-control, textarea.form-control {
	font-size: .85rem;
	line-height: 1.8rem;
}

// @media (max-width: 575.98px) {
// 	// padding-bottom: 800px;
// 	.maps iframe{
// 		width: 100% !important;
// 		// height: 450px !important;
// 	}
// }

// @media (min-width: 576px) {
// 	// padding-bottom: 800px;
// 	.maps iframe{
// 		width: 100%;
// 		// height: 450px;
// 	}
// }

// @media (min-width: 768px) {
// 	// padding-bottom: 350px;
// 	.maps iframe{
// 		width: 100%;
// 		// height: 850px;
// 	}
// }

// @media (min-width: 992px) {
// 	// padding-bottom: 200px;
// 	.maps iframe{
// 		// height: 700px;
// 	}
// }
</style>

